import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'

const { jwt } = useJwt(axios, {
  loginEndpoint: 'https://api.eddy24.ru/api/v1/auth/login',
  registerEndpoint: 'https://api.eddy24.ru/api/v1/auth/register'
})
export default jwt
